<template>
  <b-row class="match-height">
    <b-col lg="12">
      <form-page-service />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

import FormPageService from './PageService.vue'

export default {
  components: {
    BRow,
    BCol,
    FormPageInput,
    FormPageService
  },
}
</script>
